import Layout from "components/layout/Layout";
import CardField from "components/molecules/card/CardField";
import HeaderButtonGroup, { HeaderStateButton } from "components/molecules/header/HeaderButtonGroup";
import PageTitle from "components/molecules/header/PageTitle";
import BookingManagementList from "components/molecules/list/BookingManagementList";
import useSearchFilter from "hooks/useSearchFilter";
import { BookingGroupType, BookingManagementTotalPriceDto, BookingSearchObject } from "interfaces/BookingInterfaces";
import React, { FunctionComponent, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { RouteProps } from "react-router-dom";
import { bookingService } from "services/BookingService";
import { dateUtils } from "utils/dateUtils";
import { moneyUtils } from "utils/moneyUtils";

const BookingManagementListView: FunctionComponent<RouteProps> = () => {
    const intl = useIntl();
    const {searchObject, updateSearchField, onReset} = useSearchFilter<BookingSearchObject>({
        groupType : BookingGroupType.ONGOING,
        startDate: dateUtils.formatDateYYYYMMDD(dateUtils.firstDayOfTheMonth()),
        endDate: dateUtils.formatDateYYYYMMDD(dateUtils.lastDayOfTheMonth()),
        customerIds: [],
        supplierIds: [],
    });

    const [totalPrice, setTotalPrice] = useState<BookingManagementTotalPriceDto | null>(null);

    const fetchTotalPrice = (searchParams: BookingSearchObject) => {
      bookingService.getTotalPrice(searchParams)
        .then(setTotalPrice)
        .catch(() => null)
    };

    useEffect(() => {
      fetchTotalPrice(searchObject);
    }, [searchObject]);

  const updateGroupType = (groupType: BookingGroupType) => {
    updateSearchField("groupType", groupType);
  };

  const stateFilterButtons: HeaderStateButton[] = [
    {
      title: intl.formatMessage({id: "booking_management_filter_ongoing"}),
      onclick: () => updateGroupType(BookingGroupType.ONGOING),
      active: searchObject.groupType === BookingGroupType.ONGOING
    },
    {
      title: intl.formatMessage({id: "booking_management_filter_unpaid_billed"}),
      onclick: () => updateGroupType(BookingGroupType.UNPAID_BILLED),
      active: searchObject.groupType === BookingGroupType.UNPAID_BILLED
    },
    {
      title: intl.formatMessage({id: "booking_management_filter_paid_unbilled"}),
      onclick: () => updateGroupType(BookingGroupType.PAID_UNBILLED),
      active: searchObject.groupType === BookingGroupType.PAID_UNBILLED
    },
    {
      title: intl.formatMessage({id: "booking_management_filter_paid_billed"}),
      onclick: () => updateGroupType(BookingGroupType.PAID_BILLED),
      active: searchObject.groupType === BookingGroupType.PAID_BILLED
    }
  ];
    
    return (
        <Layout>
            <div className="epow-content-body d-flex flex-column">
                <div className="d-flex mb-3 align-items-center">
                  <PageTitle pageTitle={intl.formatMessage({id: "booking_management_title"})} />
                  <HeaderButtonGroup className="d-flex flex-1 justify-content-center me-5" buttonList={stateFilterButtons}/>
                  <div className="d-flex gap-4 ms-auto">
                    <CardField
                        label={intl.formatMessage({id: "booking_management_total_period"})}
                        value={moneyUtils.formatNumberToCurrency(totalPrice?.totalPriceHT)}
                    />
                    <CardField
                        label={intl.formatMessage({id: "booking_management_total_disbursement"})}
                        value={moneyUtils.formatNumberToCurrency(totalPrice?.totalDisbursementHT)}
                    />
                    <CardField
                        label={intl.formatMessage({id: "booking_management_total_billed_disbursement"})}
                        value={moneyUtils.formatNumberToCurrency(totalPrice?.totalDisbursementBilledHT)}
                    />
                  </div>
                </div>
              <BookingManagementList
                searchObject={searchObject}
                updateSearchField={updateSearchField}
                onReset={onReset}
              />
            </div>
        </Layout>
    )
}

export default BookingManagementListView;
